import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VLayout,{attrs:{"wrap":""}},[_c(VFlex,{attrs:{"xs12":""}},[_c(VCard,{staticClass:"mx-auto mt-10 mb-5",attrs:{"max-width":"50%","color":"success","dark":""}},[(_vm.page_title)?_c(VCardTitle,{staticClass:"headline"},[_vm._v(_vm._s(_vm.page_title))]):_vm._e()],1)],1),_c(VFlex,{attrs:{"xs12":""}},[_c('div',{attrs:{"id":"klarna-checkout-container"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }